import { render, staticRenderFns } from "./line3Right.vue?vue&type=template&id=6135623d&scoped=true&"
import script from "./line3Right.vue?vue&type=script&lang=js&"
export * from "./line3Right.vue?vue&type=script&lang=js&"
import style0 from "./line3Right.vue?vue&type=style&index=0&id=6135623d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135623d",
  null
  
)

export default component.exports